import { defineComponent as it, ref as Qe, onMounted as tt } from "vue";
import { useRouter as mt, useRoute as bt } from "vue-router";
var yt = "2.0.4", hi = 500, Mi = "user-agent", ce = "", Pi = "?", Ue = "function", ee = "undefined", fe = "object", mi = "string", L = "browser", W = "cpu", $ = "device", U = "engine", R = "os", se = "result", f = "name", d = "type", c = "vendor", p = "version", M = "architecture", Ae = "major", u = "model", Se = "console", m = "mobile", E = "tablet", S = "smarttv", V = "wearable", Me = "xr", Ie = "embedded", he = "inapp", xi = "brands", ne = "formFactors", Si = "fullVersionList", le = "platform", Ii = "platformVersion", We = "bitness", ie = "sec-ch-ua", Tt = ie + "-full-version-list", kt = ie + "-arch", Ct = ie + "-" + We, Et = ie + "-form-factors", xt = ie + "-" + m, St = ie + "-" + u, nt = ie + "-" + le, It = nt + "-version", rt = [xi, Si, m, u, le, Ii, M, ne, We], Pe = "Amazon", ae = "Apple", Oi = "ASUS", Fi = "BlackBerry", te = "Google", Ri = "Huawei", ei = "Lenovo", Bi = "Honor", Oe = "LG", ii = "Microsoft", ti = "Motorola", ni = "Nvidia", Di = "OnePlus", ri = "OPPO", me = "Samsung", Ni = "Sharp", be = "Sony", ai = "Xiaomi", oi = "Zebra", Hi = "Chrome", Ui = "Chromium", J = "Chromecast", De = "Edge", ye = "Firefox", Te = "Opera", si = "Facebook", qi = "Sogou", oe = "Mobile ", ke = " Browser", bi = "Windows", _t = typeof window !== ee, P = _t && window.navigator ? window.navigator : void 0, Z = P && P.userAgentData ? P.userAgentData : void 0, At = function(e, i) {
  var t = {}, o = i;
  if (!qe(i)) {
    o = {};
    for (var n in i)
      for (var l in i[n])
        o[l] = i[n][l].concat(o[l] ? o[l] : []);
  }
  for (var r in e)
    t[r] = o[r] && o[r].length % 2 === 0 ? o[r].concat(e[r]) : e[r];
  return t;
}, Ge = function(e) {
  for (var i = {}, t = 0; t < e.length; t++)
    i[e[t].toUpperCase()] = e[t];
  return i;
}, yi = function(e, i) {
  if (typeof e === fe && e.length > 0) {
    for (var t in e)
      if (G(i) == G(e[t])) return !0;
    return !1;
  }
  return ve(e) ? G(i) == G(e) : !1;
}, qe = function(e, i) {
  for (var t in e)
    return /^(browser|cpu|device|engine|os)$/.test(t) || (i ? qe(e[t]) : !1);
}, ve = function(e) {
  return typeof e === mi;
}, li = function(e) {
  if (e) {
    for (var i = [], t = pe(/\\?\"/g, e).split(","), o = 0; o < t.length; o++)
      if (t[o].indexOf(";") > -1) {
        var n = Ve(t[o]).split(";v=");
        i[o] = { brand: n[0], version: n[1] };
      } else
        i[o] = Ve(t[o]);
    return i;
  }
}, G = function(e) {
  return ve(e) ? e.toLowerCase() : e;
}, di = function(e) {
  return ve(e) ? pe(/[^\d\.]/g, e).split(".")[0] : void 0;
}, X = function(e) {
  for (var i in e) {
    var t = e[i];
    typeof t == fe && t.length == 2 ? this[t[0]] = t[1] : this[t] = void 0;
  }
  return this;
}, pe = function(e, i) {
  return ve(i) ? i.replace(e, ce) : i;
}, Ce = function(e) {
  return pe(/\\?\"/g, e);
}, Ve = function(e, i) {
  if (ve(e))
    return e = pe(/^\s\s*/, e), typeof i === ee ? e : e.substring(0, hi);
}, ui = function(e, i) {
  if (!(!e || !i))
    for (var t = 0, o, n, l, r, a, s; t < i.length && !a; ) {
      var v = i[t], g = i[t + 1];
      for (o = n = 0; o < v.length && !a && v[o]; )
        if (a = v[o++].exec(e), a)
          for (l = 0; l < g.length; l++)
            s = a[++n], r = g[l], typeof r === fe && r.length > 0 ? r.length === 2 ? typeof r[1] == Ue ? this[r[0]] = r[1].call(this, s) : this[r[0]] = r[1] : r.length >= 3 && (typeof r[1] === Ue && !(r[1].exec && r[1].test) ? r.length > 3 ? this[r[0]] = s ? r[1].apply(this, r.slice(2)) : void 0 : this[r[0]] = s ? r[1].call(this, s, r[2]) : void 0 : r.length == 3 ? this[r[0]] = s ? s.replace(r[1], r[2]) : void 0 : r.length == 4 ? this[r[0]] = s ? r[3].call(this, s.replace(r[1], r[2])) : void 0 : r.length > 4 && (this[r[0]] = s ? r[3].apply(this, [s.replace(r[1], r[2])].concat(r.slice(4))) : void 0)) : this[r] = s || void 0;
      t += 2;
    }
}, z = function(e, i) {
  for (var t in i)
    if (typeof i[t] === fe && i[t].length > 0) {
      for (var o = 0; o < i[t].length; o++)
        if (yi(i[t][o], e))
          return t === Pi ? void 0 : t;
    } else if (yi(i[t], e))
      return t === Pi ? void 0 : t;
  return i.hasOwnProperty("*") ? i["*"] : e;
}, Vi = {
  ME: "4.90",
  "NT 3.51": "3.51",
  "NT 4.0": "4.0",
  2e3: ["5.0", "5.01"],
  XP: ["5.1", "5.2"],
  Vista: "6.0",
  7: "6.1",
  8: "6.2",
  "8.1": "6.3",
  10: ["6.4", "10.0"],
  NT: ""
}, zi = {
  embedded: "Automotive",
  mobile: "Mobile",
  tablet: ["Tablet", "EInk"],
  smarttv: "TV",
  wearable: "Watch",
  xr: ["VR", "XR"],
  "?": ["Desktop", "Unknown"],
  "*": void 0
}, Lt = {
  Chrome: "Google Chrome",
  Edge: "Microsoft Edge",
  "Edge WebView2": "Microsoft Edge WebView2",
  "Chrome WebView": "Android WebView",
  "Chrome Headless": "HeadlessChrome",
  "Huawei Browser": "HuaweiBrowser",
  "MIUI Browser": "Miui Browser",
  "Opera Mobi": "OperaMobile",
  Yandex: "YaBrowser"
}, $i = {
  browser: [
    [
      // Most common regardless engine
      /\b(?:crmo|crios)\/([\w\.]+)/i
      // Chrome for Android/iOS
    ],
    [p, [f, oe + "Chrome"]],
    [
      /webview.+edge\/([\w\.]+)/i
      // Microsoft Edge
    ],
    [p, [f, De + " WebView"]],
    [
      /edg(?:e|ios|a)?\/([\w\.]+)/i
    ],
    [p, [f, "Edge"]],
    [
      // Presto based
      /(opera mini)\/([-\w\.]+)/i,
      // Opera Mini
      /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
      // Opera Mobi/Tablet
      /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
      // Opera
    ],
    [f, p],
    [
      /opios[\/ ]+([\w\.]+)/i
      // Opera mini on iphone >= 8.0
    ],
    [p, [f, Te + " Mini"]],
    [
      /\bop(?:rg)?x\/([\w\.]+)/i
      // Opera GX
    ],
    [p, [f, Te + " GX"]],
    [
      /\bopr\/([\w\.]+)/i
      // Opera Webkit
    ],
    [p, [f, Te]],
    [
      // Mixed
      /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
      // Baidu
    ],
    [p, [f, "Baidu"]],
    [
      /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
      // Maxthon
    ],
    [p, [f, "Maxthon"]],
    [
      /(kindle)\/([\w\.]+)/i,
      // Kindle
      /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
      // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
      // Trident based
      /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
      // Avant/IEMobile/SlimBrowser/SlimBoat/Slimjet
      /(?:ms|\()(ie) ([\w\.]+)/i,
      // Internet Explorer
      // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon/LG Browser/Otter/qutebrowser/Dooble
      /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon|otter|dooble|(?:lg |qute)browser)\/([-\w\.]+)/i,
      // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
      /(heytap|ovi|115|surf)browser\/([\d\.]+)/i,
      // HeyTap/Ovi/115/Surf
      /(ecosia|weibo)(?:__| \w+@)([\d\.]+)/i
      // Ecosia/Weibo
    ],
    [f, p],
    [
      /quark(?:pc)?\/([-\w\.]+)/i
      // Quark
    ],
    [p, [f, "Quark"]],
    [
      /\bddg\/([\w\.]+)/i
      // DuckDuckGo
    ],
    [p, [f, "DuckDuckGo"]],
    [
      /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
      // UCBrowser
    ],
    [p, [f, "UCBrowser"]],
    [
      /microm.+\bqbcore\/([\w\.]+)/i,
      // WeChat Desktop for Windows Built-in Browser
      /\bqbcore\/([\w\.]+).+microm/i,
      /micromessenger\/([\w\.]+)/i
      // WeChat
    ],
    [p, [f, "WeChat"]],
    [
      /konqueror\/([\w\.]+)/i
      // Konqueror
    ],
    [p, [f, "Konqueror"]],
    [
      /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
      // IE11
    ],
    [p, [f, "IE"]],
    [
      /ya(?:search)?browser\/([\w\.]+)/i
      // Yandex
    ],
    [p, [f, "Yandex"]],
    [
      /slbrowser\/([\w\.]+)/i
      // Smart Lenovo Browser
    ],
    [p, [f, "Smart " + ei + ke]],
    [
      /(avast|avg)\/([\w\.]+)/i
      // Avast/AVG Secure Browser
    ],
    [[f, /(.+)/, "$1 Secure" + ke], p],
    [
      /\bfocus\/([\w\.]+)/i
      // Firefox Focus
    ],
    [p, [f, ye + " Focus"]],
    [
      /\bopt\/([\w\.]+)/i
      // Opera Touch
    ],
    [p, [f, Te + " Touch"]],
    [
      /coc_coc\w+\/([\w\.]+)/i
      // Coc Coc Browser
    ],
    [p, [f, "Coc Coc"]],
    [
      /dolfin\/([\w\.]+)/i
      // Dolphin
    ],
    [p, [f, "Dolphin"]],
    [
      /coast\/([\w\.]+)/i
      // Opera Coast
    ],
    [p, [f, Te + " Coast"]],
    [
      /miuibrowser\/([\w\.]+)/i
      // MIUI Browser
    ],
    [p, [f, "MIUI" + ke]],
    [
      /fxios\/([\w\.-]+)/i
      // Firefox for iOS
    ],
    [p, [f, oe + ye]],
    [
      /\bqihoobrowser\/?([\w\.]*)/i
      // 360
    ],
    [p, [f, "360"]],
    [
      /\b(qq)\/([\w\.]+)/i
      // QQ
    ],
    [[f, /(.+)/, "$1Browser"], p],
    [
      /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
    ],
    [[f, /(.+)/, "$1" + ke], p],
    [
      // Oculus/Sailfish/HuaweiBrowser/VivoBrowser/PicoBrowser
      /samsungbrowser\/([\w\.]+)/i
      // Samsung Internet
    ],
    [p, [f, me + " Internet"]],
    [
      /metasr[\/ ]?([\d\.]+)/i
      // Sogou Explorer
    ],
    [p, [f, qi + " Explorer"]],
    [
      /(sogou)mo\w+\/([\d\.]+)/i
      // Sogou Mobile
    ],
    [[f, qi + " Mobile"], p],
    [
      /(electron)\/([\w\.]+) safari/i,
      // Electron-based App
      /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
      // Tesla
      /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
      // QQ/2345
    ],
    [f, p],
    [
      /(lbbrowser|rekonq)/i
      // LieBao Browser/Rekonq
    ],
    [f],
    [
      /ome\/([\w\.]+) \w* ?(iron) saf/i,
      // Iron
      /ome\/([\w\.]+).+qihu (360)[es]e/i
      // 360
    ],
    [p, f],
    [
      // WebView
      /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
      // Facebook App for iOS & Android
    ],
    [[f, si], p, [d, he]],
    [
      /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
      // Kakao App
      /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
      // Naver InApp
      /(daum)apps[\/ ]([\w\.]+)/i,
      // Daum App
      /safari (line)\/([\w\.]+)/i,
      // Line App for iOS
      /\b(line)\/([\w\.]+)\/iab/i,
      // Line App for Android
      /(alipay)client\/([\w\.]+)/i,
      // Alipay
      /(twitter)(?:and| f.+e\/([\w\.]+))/i,
      // Twitter
      /(instagram|snapchat|klarna)[\/ ]([-\w\.]+)/i
      // Instagram/Snapchat/Klarna
    ],
    [f, p, [d, he]],
    [
      /\bgsa\/([\w\.]+) .*safari\//i
      // Google Search Appliance on iOS
    ],
    [p, [f, "GSA"], [d, he]],
    [
      /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
      // TikTok
    ],
    [p, [f, "TikTok"], [d, he]],
    [
      /\[(linkedin)app\]/i
      // LinkedIn App for iOS & Android
    ],
    [f, [d, he]],
    [
      /(chromium)[\/ ]([-\w\.]+)/i
      // Chromium
    ],
    [f, p],
    [
      /headlesschrome(?:\/([\w\.]+)| )/i
      // Chrome Headless
    ],
    [p, [f, Hi + " Headless"]],
    [
      /wv\).+chrome\/([\w\.]+).+edgw\//i
      // Edge WebView2
    ],
    [p, [f, De + " WebView2"]],
    [
      / wv\).+(chrome)\/([\w\.]+)/i
      // Chrome WebView
    ],
    [[f, Hi + " WebView"], p],
    [
      /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
      // Android Browser
    ],
    [p, [f, "Android" + ke]],
    [
      /chrome\/([\w\.]+) mobile/i
      // Chrome Mobile
    ],
    [p, [f, oe + "Chrome"]],
    [
      /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
      // Chrome/OmniWeb/Arora/Tizen/Nokia
    ],
    [f, p],
    [
      /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
      // Safari Mobile
    ],
    [p, [f, oe + "Safari"]],
    [
      /iphone .*mobile(?:\/\w+ | ?)safari/i
    ],
    [[f, oe + "Safari"]],
    [
      /version\/([\w\.\,]+) .*(safari)/i
      // Safari
    ],
    [p, f],
    [
      /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
      // Safari < 3.0
    ],
    [f, [p, "1"]],
    [
      /(webkit|khtml)\/([\w\.]+)/i
    ],
    [f, p],
    [
      // Gecko based
      /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
      // Firefox Mobile
    ],
    [[f, oe + ye], p],
    [
      /(navigator|netscape\d?)\/([-\w\.]+)/i
      // Netscape
    ],
    [[f, "Netscape"], p],
    [
      /(wolvic|librewolf)\/([\w\.]+)/i
      // Wolvic/LibreWolf
    ],
    [f, p],
    [
      /mobile vr; rv:([\w\.]+)\).+firefox/i
      // Firefox Reality
    ],
    [p, [f, ye + " Reality"]],
    [
      /ekiohf.+(flow)\/([\w\.]+)/i,
      // Flow
      /(swiftfox)/i,
      // Swiftfox
      /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
      // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
      /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
      // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
      /(firefox)\/([\w\.]+)/i,
      // Other Firefox-based
      /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
      // Mozilla
      // Other
      /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
      // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
      /\b(links) \(([\w\.]+)/i
      // Links
    ],
    [f, [p, /_/g, "."]],
    [
      /(cobalt)\/([\w\.]+)/i
      // Cobalt
    ],
    [f, [p, /[^\d\.]+./, ce]]
  ],
  cpu: [
    [
      /\b((amd|x|x86[-_]?|wow|win)64)\b/i
      // AMD64 (x64)
    ],
    [[M, "amd64"]],
    [
      /(ia32(?=;))/i,
      // IA32 (quicktime)
      /\b((i[346]|x)86)(pc)?\b/i
      // IA32 (x86)
    ],
    [[M, "ia32"]],
    [
      /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
      // ARM64
    ],
    [[M, "arm64"]],
    [
      /\b(arm(v[67])?ht?n?[fl]p?)\b/i
      // ARMHF
    ],
    [[M, "armhf"]],
    [
      // PocketPC mistakenly identified as PowerPC
      /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
    ],
    [[M, "arm"]],
    [
      /((ppc|powerpc)(64)?)( mac|;|\))/i
      // PowerPC
    ],
    [[M, /ower/, ce, G]],
    [
      / sun4\w[;\)]/i
      // SPARC
    ],
    [[M, "sparc"]],
    [
      /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
      // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
    ],
    [[M, G]]
  ],
  device: [
    [
      //////////////////////////
      // MOBILES & TABLETS
      /////////////////////////
      // Samsung
      /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
    ],
    [u, [c, me], [d, E]],
    [
      /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
      /samsung[- ]((?!sm-[lr]|browser)[-\w]+)/i,
      /sec-(sgh\w+)/i
    ],
    [u, [c, me], [d, m]],
    [
      // Apple
      /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
      // iPod/iPhone
    ],
    [u, [c, ae], [d, m]],
    [
      /\((ipad);[-\w\),; ]+apple/i,
      // iPad
      /applecoremedia\/[\w\.]+ \((ipad)/i,
      /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
    ],
    [u, [c, ae], [d, E]],
    [
      /(macintosh);/i
    ],
    [u, [c, ae]],
    [
      // Sharp
      /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
    ],
    [u, [c, Ni], [d, m]],
    [
      // Honor
      /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
    ],
    [u, [c, Bi], [d, E]],
    [
      /honor([-\w ]+)[;\)]/i
    ],
    [u, [c, Bi], [d, m]],
    [
      // Huawei
      /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
    ],
    [u, [c, Ri], [d, E]],
    [
      /(?:huawei)([-\w ]+)[;\)]/i,
      /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
    ],
    [u, [c, Ri], [d, m]],
    [
      // Xiaomi
      /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
      /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
      // Mi Pad tablets
    ],
    [[u, /_/g, " "], [c, ai], [d, E]],
    [
      /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
      // Xiaomi POCO
      /\b; (\w+) build\/hm\1/i,
      // Xiaomi Hongmi 'numeric' models
      /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
      // Xiaomi Hongmi
      /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
      // Xiaomi Redmi
      /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
      // Xiaomi Redmi 'numeric' models
      /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
      // Xiaomi Mi
      / ([\w ]+) miui\/v?\d/i
    ],
    [[u, /_/g, " "], [c, ai], [d, m]],
    [
      // OnePlus
      /droid.+; (cph2[3-6]\d[13579]|((gm|hd)19|(ac|be|in|kb)20|(d[en]|eb|le|mt)21|ne22)[0-2]\d|p[g-k]\w[1m]10)\b/i,
      /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
    ],
    [u, [c, Di], [d, m]],
    [
      // OPPO
      /; (\w+) bui.+ oppo/i,
      /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
    ],
    [u, [c, ri], [d, m]],
    [
      /\b(opd2(\d{3}a?))(?: bui|\))/i
    ],
    [u, [c, z, { OnePlus: ["203", "304", "403", "404", "413", "415"], "*": ri }], [d, E]],
    [
      // BLU
      /(vivo (5r?|6|8l?|go|one|s|x[il]?[2-4]?)[\w\+ ]*)(?: bui|\))/i
      // Vivo series
    ],
    [u, [c, "BLU"], [d, m]],
    [
      // Vivo
      /; vivo (\w+)(?: bui|\))/i,
      /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
    ],
    [u, [c, "Vivo"], [d, m]],
    [
      // Realme
      /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
    ],
    [u, [c, "Realme"], [d, m]],
    [
      // Lenovo
      /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
      /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
    ],
    [u, [c, ei], [d, E]],
    [
      /lenovo[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i
    ],
    [u, [c, ei], [d, m]],
    [
      // Motorola
      /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
      /\bmot(?:orola)?[- ]([\w\s]+)(\)| bui)/i,
      /((?:moto(?! 360)[-\w\(\) ]+|xt\d{3,4}[cgkosw\+]?[-\d]*|nexus 6)(?= bui|\)))/i
    ],
    [u, [c, ti], [d, m]],
    [
      /\b(mz60\d|xoom[2 ]{0,2}) build\//i
    ],
    [u, [c, ti], [d, E]],
    [
      // LG
      /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
    ],
    [u, [c, Oe], [d, E]],
    [
      /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
      /\blg[-e;\/ ]+(?!.*(?:browser|netcast|android tv|watch|webos))(\w+)/i,
      /\blg-?([\d\w]+) bui/i
    ],
    [u, [c, Oe], [d, m]],
    [
      // Nokia
      /(nokia) (t[12][01])/i
    ],
    [c, u, [d, E]],
    [
      /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
      /nokia[-_ ]?(([-\w\. ]*))/i
    ],
    [[u, /_/g, " "], [d, m], [c, "Nokia"]],
    [
      // Google
      /(pixel (c|tablet))\b/i
      // Google Pixel C/Tablet
    ],
    [u, [c, te], [d, E]],
    [
      // Google Pixel
      /droid.+;(?: google)? (g(01[13]a|020[aem]|025[jn]|1b60|1f8f|2ybb|4s1m|576d|5nz6|8hhn|8vou|a02099|c15s|d1yq|e2ae|ec77|gh2x|kv4x|p4bc|pj41|r83y|tt9q|ur25|wvk6)|pixel[\d ]*a?( pro)?( xl)?( fold)?( \(5g\))?)( bui|\))/i
    ],
    [u, [c, te], [d, m]],
    [
      /(google) (pixelbook( go)?)/i
    ],
    [c, u],
    [
      // Sony
      /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-\w\w\d\d)(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
    ],
    [u, [c, be], [d, m]],
    [
      /sony tablet [ps]/i,
      /\b(?:sony)?sgp\w+(?: bui|\))/i
    ],
    [[u, "Xperia Tablet"], [c, be], [d, E]],
    [
      // Amazon
      /(alexa)webm/i,
      /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
      // Kindle Fire without Silk / Echo Show
      /(kf[a-z]+)( bui|\)).+silk\//i
      // Kindle Fire HD
    ],
    [u, [c, Pe], [d, E]],
    [
      /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
      // Fire Phone
    ],
    [[u, /(.+)/g, "Fire Phone $1"], [c, Pe], [d, m]],
    [
      // BlackBerry
      /(playbook);[-\w\),; ]+(rim)/i
      // BlackBerry PlayBook
    ],
    [u, c, [d, E]],
    [
      /\b((?:bb[a-f]|st[hv])100-\d)/i,
      /\(bb10; (\w+)/i
      // BlackBerry 10
    ],
    [u, [c, Fi], [d, m]],
    [
      // Asus
      /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
    ],
    [u, [c, Oi], [d, E]],
    [
      / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
    ],
    [u, [c, Oi], [d, m]],
    [
      // HTC
      /(nexus 9)/i
      // HTC Nexus 9
    ],
    [u, [c, "HTC"], [d, E]],
    [
      /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
      // HTC
      // ZTE
      /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
      /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
      // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
    ],
    [c, [u, /_/g, " "], [d, m]],
    [
      // TCL
      /tcl (xess p17aa)/i,
      /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [u, [c, "TCL"], [d, E]],
    [
      /droid [\w\.]+; (418(?:7d|8v)|5087z|5102l|61(?:02[dh]|25[adfh]|27[ai]|56[dh]|59k|65[ah])|a509dl|t(?:43(?:0w|1[adepqu])|50(?:6d|7[adju])|6(?:09dl|10k|12b|71[efho]|76[hjk])|7(?:66[ahju]|67[hw]|7[045][bh]|71[hk]|73o|76[ho]|79w|81[hks]?|82h|90[bhsy]|99b)|810[hs]))(_\w(\w|\w\w))?(\)| bui)/i
    ],
    [u, [c, "TCL"], [d, m]],
    [
      // itel
      /(itel) ((\w+))/i
    ],
    [[c, G], u, [d, z, { tablet: ["p10001l", "w7001"], "*": "mobile" }]],
    [
      // Acer
      /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
    ],
    [u, [c, "Acer"], [d, E]],
    [
      // Meizu
      /droid.+; (m[1-5] note) bui/i,
      /\bmz-([-\w]{2,})/i
    ],
    [u, [c, "Meizu"], [d, m]],
    [
      // Ulefone
      /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
    ],
    [u, [c, "Ulefone"], [d, m]],
    [
      // Energizer
      /; (energy ?\w+)(?: bui|\))/i,
      /; energizer ([\w ]+)(?: bui|\))/i
    ],
    [u, [c, "Energizer"], [d, m]],
    [
      // Cat
      /; cat (b35);/i,
      /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
    ],
    [u, [c, "Cat"], [d, m]],
    [
      // Smartfren
      /((?:new )?andromax[\w- ]+)(?: bui|\))/i
    ],
    [u, [c, "Smartfren"], [d, m]],
    [
      // Nothing
      /droid.+; (a(in)?(0(15|59|6[35])|142)p?)/i
    ],
    [u, [c, "Nothing"], [d, m]],
    [
      // Archos
      /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
      /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
    ],
    [u, [c, "Archos"], [d, E]],
    [
      /archos ([\w ]+)( b|\))/i,
      /; (ac[3-6]\d\w{2,8})( b|\))/i
    ],
    [u, [c, "Archos"], [d, m]],
    [
      // HMD
      /; (n159v)/i
    ],
    [u, [c, "HMD"], [d, m]],
    [
      // MIXED
      /(imo) (tab \w+)/i,
      // IMO
      /(infinix|tecno) (x1101b?|p904|dp(7c|8d|10a)( pro)?|p70[1-3]a?|p904|t1101)/i
      // Infinix XPad / Tecno
    ],
    [c, u, [d, E]],
    [
      /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
      // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Tecno/Micromax/Advan
      /; (blu|hmd|imo|infinix|lava|oneplus|tcl)[_ ]([\w\+ ]+?)(?: bui|\)|; r)/i,
      // BLU/HMD/IMO/Infinix/Lava/OnePlus/TCL
      /(hp) ([\w ]+\w)/i,
      // HP iPAQ
      /(microsoft); (lumia[\w ]+)/i,
      // Microsoft Lumia
      /(oppo) ?([\w ]+) bui/i
      // OPPO
    ],
    [c, u, [d, m]],
    [
      /(kobo)\s(ereader|touch)/i,
      // Kobo
      /(hp).+(touchpad(?!.+tablet)|tablet)/i,
      // HP TouchPad
      /(kindle)\/([\w\.]+)/i
      // Kindle
    ],
    [c, u, [d, E]],
    [
      /(surface duo)/i
      // Surface Duo
    ],
    [u, [c, ii], [d, E]],
    [
      /droid [\d\.]+; (fp\du?)(?: b|\))/i
      // Fairphone
    ],
    [u, [c, "Fairphone"], [d, m]],
    [
      /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
      // Nvidia Tablets
    ],
    [u, [c, ni], [d, E]],
    [
      /(sprint) (\w+)/i
      // Sprint Phones
    ],
    [c, u, [d, m]],
    [
      /(kin\.[onetw]{3})/i
      // Microsoft Kin
    ],
    [[u, /\./g, " "], [c, ii], [d, m]],
    [
      /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
      // Zebra
    ],
    [u, [c, oi], [d, E]],
    [
      /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
    ],
    [u, [c, oi], [d, m]],
    [
      ///////////////////
      // SMARTTVS
      ///////////////////
      /smart-tv.+(samsung)/i
      // Samsung
    ],
    [c, [d, S]],
    [
      /hbbtv.+maple;(\d+)/i
    ],
    [[u, /^/, "SmartTV"], [c, me], [d, S]],
    [
      /(vizio)(?: |.+model\/)(\w+-\w+)/i,
      // Vizio
      /tcast.+(lg)e?. ([-\w]+)/i
      // LG SmartTV
    ],
    [c, u, [d, S]],
    [
      /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
    ],
    [[c, Oe], [d, S]],
    [
      /(apple) ?tv/i
      // Apple TV
    ],
    [c, [u, ae + " TV"], [d, S]],
    [
      /crkey.*devicetype\/chromecast/i
      // Google Chromecast Third Generation
    ],
    [[u, J + " Third Generation"], [c, te], [d, S]],
    [
      /crkey.*devicetype\/([^/]*)/i
      // Google Chromecast with specific device type
    ],
    [[u, /^/, "Chromecast "], [c, te], [d, S]],
    [
      /fuchsia.*crkey/i
      // Google Chromecast Nest Hub
    ],
    [[u, J + " Nest Hub"], [c, te], [d, S]],
    [
      /crkey/i
      // Google Chromecast, Linux-based or unknown
    ],
    [[u, J], [c, te], [d, S]],
    [
      /(portaltv)/i
      // Facebook Portal TV
    ],
    [u, [c, si], [d, S]],
    [
      /droid.+aft(\w+)( bui|\))/i
      // Fire TV
    ],
    [u, [c, Pe], [d, S]],
    [
      /(shield \w+ tv)/i
      // Nvidia Shield TV
    ],
    [u, [c, ni], [d, S]],
    [
      /\(dtv[\);].+(aquos)/i,
      /(aquos-tv[\w ]+)\)/i
      // Sharp
    ],
    [u, [c, Ni], [d, S]],
    [
      /(bravia[\w ]+)( bui|\))/i
      // Sony
    ],
    [u, [c, be], [d, S]],
    [
      /(mi(tv|box)-?\w+) bui/i
      // Xiaomi
    ],
    [u, [c, ai], [d, S]],
    [
      /Hbbtv.*(technisat) (.*);/i
      // TechniSAT
    ],
    [c, u, [d, S]],
    [
      /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
      // Roku
      /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
      // HbbTV devices
    ],
    [[c, /.+\/(\w+)/, "$1", z, { LG: "lge" }], [u, Ve], [d, S]],
    [
      // SmartTV from Unidentified Vendors
      /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
    ],
    [u, [d, S]],
    [
      /\b(android tv|smart[- ]?tv|opera tv|tv; rv:|large screen[\w ]+safari)\b/i
    ],
    [[d, S]],
    [
      ///////////////////
      // CONSOLES
      ///////////////////
      /(playstation \w+)/i
      // Playstation
    ],
    [u, [c, be], [d, Se]],
    [
      /\b(xbox(?: one)?(?!; xbox))[\); ]/i
      // Microsoft Xbox
    ],
    [u, [c, ii], [d, Se]],
    [
      /(ouya)/i,
      // Ouya
      /(nintendo) (\w+)/i,
      // Nintendo
      /(retroid) (pocket ([^\)]+))/i
      // Retroid Pocket
    ],
    [c, u, [d, Se]],
    [
      /droid.+; (shield)( bui|\))/i
      // Nvidia Portable
    ],
    [u, [c, ni], [d, Se]],
    [
      ///////////////////
      // WEARABLES
      ///////////////////
      /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
      // Samsung Galaxy Watch
    ],
    [u, [c, me], [d, V]],
    [
      /((pebble))app/i,
      // Pebble
      /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
      // Asus ZenWatch / LG Watch / Pixel Watch
    ],
    [c, u, [d, V]],
    [
      /(ow(?:19|20)?we?[1-3]{1,3})/i
      // Oppo Watch
    ],
    [u, [c, ri], [d, V]],
    [
      /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
      // Apple Watch
    ],
    [u, [c, ae], [d, V]],
    [
      /(opwwe\d{3})/i
      // OnePlus Watch
    ],
    [u, [c, Di], [d, V]],
    [
      /(moto 360)/i
      // Motorola 360
    ],
    [u, [c, ti], [d, V]],
    [
      /(smartwatch 3)/i
      // Sony SmartWatch
    ],
    [u, [c, be], [d, V]],
    [
      /(g watch r)/i
      // LG G Watch R
    ],
    [u, [c, Oe], [d, V]],
    [
      /droid.+; (wt63?0{2,3})\)/i
    ],
    [u, [c, oi], [d, V]],
    [
      ///////////////////
      // XR
      ///////////////////
      /droid.+; (glass) \d/i
      // Google Glass
    ],
    [u, [c, te], [d, Me]],
    [
      /(pico) (4|neo3(?: link|pro)?)/i
      // Pico
    ],
    [c, u, [d, Me]],
    [
      /(quest( \d| pro)?s?).+vr/i
      // Meta Quest
    ],
    [u, [c, si], [d, Me]],
    [
      /mobile vr; rv.+firefox/i
      // Unidentifiable VR device using Firefox Reality / Wolvic
    ],
    [[d, Me]],
    [
      ///////////////////
      // EMBEDDED
      ///////////////////
      /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
      // Tesla
    ],
    [c, [d, Ie]],
    [
      /(aeobc)\b/i
      // Echo Dot
    ],
    [u, [c, Pe], [d, Ie]],
    [
      /(homepod).+mac os/i
      // Apple HomePod
    ],
    [u, [c, ae], [d, Ie]],
    [
      /windows iot/i
      // Unidentifiable embedded device using Windows IoT
    ],
    [[d, Ie]],
    [
      ////////////////////
      // MIXED (GENERIC)
      ///////////////////
      /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+?(mobile|vr|\d) safari/i
    ],
    [u, [d, z, { mobile: "Mobile", xr: "VR", "*": E }]],
    [
      /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
      // Unidentifiable Tablet
    ],
    [[d, E]],
    [
      /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
      // Unidentifiable Mobile
    ],
    [[d, m]],
    [
      /droid .+?; ([\w\. -]+)( bui|\))/i
      // Generic Android Device
    ],
    [u, [c, "Generic"]]
  ],
  engine: [
    [
      /windows.+ edge\/([\w\.]+)/i
      // EdgeHTML
    ],
    [p, [f, De + "HTML"]],
    [
      /(arkweb)\/([\w\.]+)/i
      // ArkWeb
    ],
    [f, p],
    [
      /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
      // Blink
    ],
    [p, [f, "Blink"]],
    [
      /(presto)\/([\w\.]+)/i,
      // Presto
      /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
      // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna/Servo
      /ekioh(flow)\/([\w\.]+)/i,
      // Flow
      /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
      // KHTML/Tasman/Links
      /(icab)[\/ ]([23]\.[\d\.]+)/i,
      // iCab
      /\b(libweb)/i
      // LibWeb
    ],
    [f, p],
    [
      /ladybird\//i
    ],
    [[f, "LibWeb"]],
    [
      /rv\:([\w\.]{1,9})\b.+(gecko)/i
      // Gecko
    ],
    [p, f]
  ],
  os: [
    [
      // Windows
      /(windows nt) (6\.[23]); arm/i
      // Windows RT
    ],
    [[f, /N/, "R"], [p, z, Vi]],
    [
      /(windows (?:phone|mobile|iot))(?: os)?[\/ ]?([\d\.]*( se)?)/i,
      // Windows IoT/Mobile/Phone
      // Windows NT/3.1/95/98/ME/2000/XP/Vista/7/8/8.1/10/11
      /(windows)[\/ ](1[01]|2000|3\.1|7|8(\.1)?|9[58]|me|server 20\d\d( r2)?|vista|xp)/i
    ],
    [f, p],
    [
      /windows nt ?([\d\.\)]*)(?!.+xbox)/i,
      /\bwin(?=3| ?9|n)(?:nt| 9x )?([\d\.;]*)/i
    ],
    [[p, /(;|\))/g, "", z, Vi], [f, bi]],
    [
      /(windows ce)\/?([\d\.]*)/i
      // Windows CE
    ],
    [f, p],
    [
      // iOS/macOS
      /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
      // iOS
      /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
      /cfnetwork\/.+darwin/i
    ],
    [[p, /_/g, "."], [f, "iOS"]],
    [
      /(mac os x) ?([\w\. ]*)/i,
      /(macintosh|mac_powerpc\b)(?!.+(haiku|morphos))/i
      // Mac OS
    ],
    [[f, "macOS"], [p, /_/g, "."]],
    [
      // Google Chromecast
      /android ([\d\.]+).*crkey/i
      // Google Chromecast, Android-based
    ],
    [p, [f, J + " Android"]],
    [
      /fuchsia.*crkey\/([\d\.]+)/i
      // Google Chromecast, Fuchsia-based
    ],
    [p, [f, J + " Fuchsia"]],
    [
      /crkey\/([\d\.]+).*devicetype\/smartspeaker/i
      // Google Chromecast, Linux-based Smart Speaker
    ],
    [p, [f, J + " SmartSpeaker"]],
    [
      /linux.*crkey\/([\d\.]+)/i
      // Google Chromecast, Legacy Linux-based
    ],
    [p, [f, J + " Linux"]],
    [
      /crkey\/([\d\.]+)/i
      // Google Chromecast, unknown
    ],
    [p, [f, J]],
    [
      // Mobile OSes
      /droid ([\w\.]+)\b.+(android[- ]x86)/i
      // Android-x86
    ],
    [p, f],
    [
      /(ubuntu) ([\w\.]+) like android/i
      // Ubuntu Touch
    ],
    [[f, /(.+)/, "$1 Touch"], p],
    [
      /(harmonyos)[\/ ]?([\d\.]*)/i,
      // HarmonyOS
      // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
      /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen)\w*[-\/\.; ]?([\d\.]*)/i
    ],
    [f, p],
    [
      /\(bb(10);/i
      // BlackBerry 10
    ],
    [p, [f, Fi]],
    [
      /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
      // Symbian
    ],
    [p, [f, "Symbian"]],
    [
      /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
      // Firefox OS
    ],
    [p, [f, ye + " OS"]],
    [
      /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i,
      // WebOS
      /webos(?:[ \/]?|\.tv-20(?=2[2-9]))(\d[\d\.]*)/i
    ],
    [p, [f, "webOS"]],
    [
      /web0s;.+?(?:chr[o0]me|safari)\/(\d+)/i
      // https://webostv.developer.lge.com/develop/specifications/web-api-and-web-engine
    ],
    [[p, z, { 25: "120", 24: "108", 23: "94", 22: "87", 6: "79", 5: "68", 4: "53", 3: "38", 2: "538", 1: "537", "*": "TV" }], [f, "webOS"]],
    [
      /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
      // watchOS
    ],
    [p, [f, "watchOS"]],
    [
      // Google ChromeOS
      /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
      // Chromium OS
    ],
    [[f, "Chrome OS"], p],
    [
      // Smart TVs
      /panasonic;(viera)/i,
      // Panasonic Viera
      /(netrange)mmh/i,
      // Netrange
      /(nettv)\/(\d+\.[\w\.]+)/i,
      // NetTV
      // Console
      /(nintendo|playstation) (\w+)/i,
      // Nintendo/Playstation
      /(xbox); +xbox ([^\);]+)/i,
      // Microsoft Xbox (360, One, X, S, Series X, Series S)
      /(pico) .+os([\w\.]+)/i,
      // Pico
      // Other
      /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
      // Joli/Palm
      /linux.+(mint)[\/\(\) ]?([\w\.]*)/i,
      // Mint
      /(mageia|vectorlinux|fuchsia|arcaos|arch(?= ?linux))[;l ]([\d\.]*)/i,
      // Mageia/VectorLinux/Fuchsia/ArcaOS/Arch
      /([kxln]?ubuntu|debian|suse|opensuse|gentoo|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire|knoppix)(?: gnu[\/ ]linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
      // Ubuntu/Debian/SUSE/Gentoo/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire/Knoppix
      /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
      // Solaris
      /\b(aix)[; ]([1-9\.]{0,4})/i,
      // AIX
      /(hurd|linux|morphos)(?: (?:arm|x86|ppc)\w*| ?)([\w\.]*)/i,
      // Hurd/Linux/MorphOS
      /(gnu) ?([\w\.]*)/i,
      // GNU
      /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
      // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
      /(haiku) ?(r\d)?/i
      // Haiku
    ],
    [f, p],
    [
      /(sunos) ?([\d\.]*)/i
      // Solaris
    ],
    [[f, "Solaris"], p],
    [
      /\b(beos|os\/2|amigaos|openvms|hp-ux|serenityos)/i,
      // BeOS/OS2/AmigaOS/OpenVMS/HP-UX/SerenityOS
      /(unix) ?([\w\.]*)/i
      // UNIX
    ],
    [f, p]
  ]
}, Fe = function() {
  var e = { init: {}, isIgnore: {}, isIgnoreRgx: {}, toString: {} };
  return X.call(e.init, [
    [L, [f, p, Ae, d]],
    [W, [M]],
    [$, [d, u, c]],
    [U, [f, p]],
    [R, [f, p]]
  ]), X.call(e.isIgnore, [
    [L, [p, Ae]],
    [U, [p]],
    [R, [p]]
  ]), X.call(e.isIgnoreRgx, [
    [L, / ?browser$/i],
    [R, / ?os$/i]
  ]), X.call(e.toString, [
    [L, [f, p]],
    [W, [M]],
    [$, [c, u]],
    [U, [f, p]],
    [R, [f, p]]
  ]), e;
}(), Mt = function(e, i) {
  var t = Fe.init[i], o = Fe.isIgnore[i] || 0, n = Fe.isIgnoreRgx[i] || 0, l = Fe.toString[i] || 0;
  function r() {
    X.call(this, t);
  }
  return r.prototype.getItem = function() {
    return e;
  }, r.prototype.withClientHints = function() {
    return Z ? Z.getHighEntropyValues(rt).then(function(a) {
      return e.setCH(new at(a, !1)).parseCH().get();
    }) : e.parseCH().get();
  }, r.prototype.withFeatureCheck = function() {
    return e.detectFeature().get();
  }, i != se && (r.prototype.is = function(a) {
    var s = !1;
    for (var v in this)
      if (this.hasOwnProperty(v) && !yi(o, v) && G(n ? pe(n, this[v]) : this[v]) == G(n ? pe(n, a) : a)) {
        if (s = !0, a != ee) break;
      } else if (a == ee && s) {
        s = !s;
        break;
      }
    return s;
  }, r.prototype.toString = function() {
    var a = ce;
    for (var s in l)
      typeof this[l[s]] !== ee && (a += (a ? " " : ce) + this[l[s]]);
    return a || ee;
  }), Z || (r.prototype.then = function(a) {
    var s = this, v = function() {
      for (var h in s)
        s.hasOwnProperty(h) && (this[h] = s[h]);
    };
    v.prototype = {
      is: r.prototype.is,
      toString: r.prototype.toString
    };
    var g = new v();
    return a(g), g;
  }), new r();
};
function at(e, i) {
  if (e = e || {}, X.call(this, rt), i)
    X.call(this, [
      [xi, li(e[ie])],
      [Si, li(e[Tt])],
      [m, /\?1/.test(e[xt])],
      [u, Ce(e[St])],
      [le, Ce(e[nt])],
      [Ii, Ce(e[It])],
      [M, Ce(e[kt])],
      [ne, li(e[Et])],
      [We, Ce(e[Ct])]
    ]);
  else
    for (var t in e)
      this.hasOwnProperty(t) && typeof e[t] !== ee && (this[t] = e[t]);
}
function ji(e, i, t, o) {
  return this.get = function(n) {
    return n ? this.data.hasOwnProperty(n) ? this.data[n] : void 0 : this.data;
  }, this.set = function(n, l) {
    return this.data[n] = l, this;
  }, this.setCH = function(n) {
    return this.uaCH = n, this;
  }, this.detectFeature = function() {
    if (P && P.userAgent == this.ua)
      switch (this.itemType) {
        case L:
          P.brave && typeof P.brave.isBrave == Ue && this.set(f, "Brave");
          break;
        case $:
          !this.get(d) && Z && Z[m] && this.set(d, m), this.get(u) == "Macintosh" && P && typeof P.standalone !== ee && P.maxTouchPoints && P.maxTouchPoints > 2 && this.set(u, "iPad").set(d, E);
          break;
        case R:
          !this.get(f) && Z && Z[le] && this.set(f, Z[le]);
          break;
        case se:
          var n = this.data, l = function(r) {
            return n[r].getItem().detectFeature().get();
          };
          this.set(L, l(L)).set(W, l(W)).set($, l($)).set(U, l(U)).set(R, l(R));
      }
    return this;
  }, this.parseUA = function() {
    return this.itemType != se && ui.call(this.data, this.ua, this.rgxMap), this.itemType == L && this.set(Ae, di(this.get(p))), this;
  }, this.parseCH = function() {
    var n = this.uaCH, l = this.rgxMap;
    switch (this.itemType) {
      case L:
      case U:
        var r = n[Si] || n[xi], a;
        if (r)
          for (var s in r) {
            var v = r[s].brand || r[s], g = r[s].version;
            this.itemType == L && !/not.a.brand/i.test(v) && (!a || /Chrom/.test(a) && v != Ui || a == De && /WebView2/.test(v)) && (v = z(v, Lt), a = this.get(f), a && !/Chrom/.test(a) && /Chrom/.test(v) || this.set(f, v).set(p, g).set(Ae, di(g)), a = v), this.itemType == U && v == Ui && this.set(p, g);
          }
        break;
      case W:
        var h = n[M];
        h && (h && n[We] == "64" && (h += "64"), ui.call(this.data, h + ";", l));
        break;
      case $:
        if (n[m] && this.set(d, m), n[u] && (this.set(u, n[u]), !this.get(d) || !this.get(c))) {
          var w = {};
          ui.call(w, "droid 9; " + n[u] + ")", l), !this.get(d) && w.type && this.set(d, w.type), !this.get(c) && w.vendor && this.set(c, w.vendor);
        }
        if (n[ne]) {
          var y;
          if (typeof n[ne] != "string")
            for (var C = 0; !y && C < n[ne].length; )
              y = z(n[ne][C++], zi);
          else
            y = z(n[ne], zi);
          this.set(d, y);
        }
        break;
      case R:
        var b = n[le];
        if (b) {
          var k = n[Ii];
          b == bi && (k = parseInt(di(k), 10) >= 13 ? "11" : "10"), this.set(f, b).set(p, k);
        }
        this.get(f) == bi && n[u] == "Xbox" && this.set(f, "Xbox").set(p, void 0);
        break;
      case se:
        var I = this.data, A = function(Y) {
          return I[Y].getItem().setCH(n).parseCH().get();
        };
        this.set(L, A(L)).set(W, A(W)).set($, A($)).set(U, A(U)).set(R, A(R));
    }
    return this;
  }, X.call(this, [
    ["itemType", e],
    ["ua", i],
    ["uaCH", o],
    ["rgxMap", t],
    ["data", Mt(this, e)]
  ]), this;
}
function K(e, i, t) {
  if (typeof e === fe ? (qe(e, !0) ? (typeof i === fe && (t = i), i = e) : (t = e, i = void 0), e = void 0) : typeof e === mi && !qe(i, !0) && (t = i, i = void 0), t && typeof t.append === Ue) {
    var o = {};
    t.forEach(function(s, v) {
      o[v] = s;
    }), t = o;
  }
  if (!(this instanceof K))
    return new K(e, i, t).getResult();
  var n = typeof e === mi ? e : (
    // Passed user-agent string
    t && t[Mi] ? t[Mi] : (
      // User-Agent from passed headers
      P && P.userAgent ? P.userAgent : (
        // navigator.userAgent
        ce
      )
    )
  ), l = new at(t, !0), r = i ? At($i, i) : $i, a = function(s) {
    return s == se ? function() {
      return new ji(s, n, r, l).set("ua", n).set(L, this.getBrowser()).set(W, this.getCPU()).set($, this.getDevice()).set(U, this.getEngine()).set(R, this.getOS()).get();
    } : function() {
      return new ji(s, n, r[s], l).parseUA().get();
    };
  };
  return X.call(this, [
    ["getBrowser", a(L)],
    ["getCPU", a(W)],
    ["getDevice", a($)],
    ["getEngine", a(U)],
    ["getOS", a(R)],
    ["getResult", a(se)],
    ["getUA", function() {
      return n;
    }],
    ["setUA", function(s) {
      return ve(s) && (n = s.length > hi ? Ve(s, hi) : s), this;
    }]
  ]).setUA(n), this;
}
K.VERSION = yt;
K.BROWSER = Ge([f, p, Ae, d]);
K.CPU = Ge([M]);
K.DEVICE = Ge([u, c, d, Se, m, S, E, V, Ie]);
K.ENGINE = K.OS = Ge([f, p]);
var Ti, Wi, D = function() {
  var e = self.performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
  if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
}, ze = function(e) {
  if (document.readyState === "loading") return "loading";
  var i = D();
  if (i) {
    if (e < i.domInteractive) return "loading";
    if (i.domContentLoadedEventStart === 0 || e < i.domContentLoadedEventStart) return "dom-interactive";
    if (i.domComplete === 0 || e < i.domComplete) return "dom-content-loaded";
  }
  return "complete";
}, Pt = function(e) {
  var i = e.nodeName;
  return e.nodeType === 1 ? i.toLowerCase() : i.toUpperCase().replace(/^#/, "");
}, _i = function(e, i) {
  var t = "";
  try {
    for (; e && e.nodeType !== 9; ) {
      var o = e, n = o.id ? "#" + o.id : Pt(o) + (o.classList && o.classList.value && o.classList.value.trim() && o.classList.value.trim().length ? "." + o.classList.value.trim().replace(/\s+/g, ".") : "");
      if (t.length + n.length > (i || 100) - 1) return t || n;
      if (t = t ? n + ">" + t : n, o.id) break;
      e = o.parentNode;
    }
  } catch {
  }
  return t;
}, O = function(e, i, t, o) {
  var n, l;
  return function(r) {
    i.value >= 0 && (r || o) && ((l = i.value - (n || 0)) || n === void 0) && (n = i.value, i.delta = l, i.rating = function(a, s) {
      return a > s[1] ? "poor" : a > s[0] ? "needs-improvement" : "good";
    }(i.value, t), e(i));
  };
}, Xe = function(e) {
  requestAnimationFrame(function() {
    return requestAnimationFrame(function() {
      return e();
    });
  });
}, ot = -1, st = function() {
  return ot;
}, we = function(e) {
  addEventListener("pageshow", function(i) {
    i.persisted && (ot = i.timeStamp, e(i));
  }, !0);
}, Ke = function() {
  var e = D();
  return e && e.activationStart || 0;
}, N = function(e, i, t, o) {
  var n, l = ((n = D()) === null || n === void 0 ? void 0 : n.navigationId) || "1", r = D(), a = "navigate";
  return t ? a = t : st() >= 0 ? a = "back-forward-cache" : r && (document.prerendering || Ke() > 0 ? a = "prerender" : document.wasDiscarded ? a = "restore" : r.type && (a = r.type.replace(/_/g, "-"))), { name: e, value: i === void 0 ? -1 : i, rating: "good", delta: 0, entries: [], id: "v4-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12), navigationType: a, navigationId: o || l };
}, ge = function(e) {
  return PerformanceObserver.supportedEntryTypes.includes("soft-navigation") && e && e.reportSoftNavs;
}, B = function(e) {
  if (e) {
    var i = window.performance.getEntriesByType("soft-navigation").filter(function(t) {
      return t.navigationId === e;
    });
    return i ? i[0] : void 0;
  }
}, j = function(e, i, t) {
  var o = ge(t);
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      var n = new PerformanceObserver(function(l) {
        Promise.resolve().then(function() {
          i(l.getEntries());
        });
      });
      return n.observe(Object.assign({ type: e, buffered: !0, includeSoftNavigationObservations: o }, t || {})), n;
    }
  } catch {
  }
}, Ye = function(e) {
  document.addEventListener("visibilitychange", function() {
    document.visibilityState === "hidden" && e();
  });
}, lt = function(e) {
  var i = !1;
  return function() {
    i || (e(), i = !0);
  };
}, re = -1, Gi = function() {
  return document.visibilityState !== "hidden" || document.prerendering ? 1 / 0 : 0;
}, $e = function(e) {
  document.visibilityState === "hidden" && re > -1 && (re = e.type === "visibilitychange" ? e.timeStamp : 0, Ot());
}, Xi = function() {
  addEventListener("visibilitychange", $e, !0), addEventListener("prerenderingchange", $e, !0);
}, Ot = function() {
  removeEventListener("visibilitychange", $e, !0), removeEventListener("prerenderingchange", $e, !0);
}, je = function() {
  return arguments.length > 0 && arguments[0] !== void 0 && arguments[0] && (re = -1), re < 0 && (re = Gi(), Xi(), we(function() {
    setTimeout(function() {
      re = Gi(), Xi();
    }, 0);
  })), { get firstHiddenTime() {
    return re;
  } };
}, Je = function(e) {
  document.prerendering ? addEventListener("prerenderingchange", function() {
    return e();
  }, !0) : e();
}, ci = [1800, 3e3], dt = function(e, i) {
  var t, o = ge(i = i || {}), n = 0, l = ((t = D()) === null || t === void 0 ? void 0 : t.navigationId) || "1";
  Je(function() {
    var r, a = je(), s = N("FCP"), v = j("paint", function(g) {
      g.forEach(function(h) {
        if (h.name === "first-contentful-paint") {
          o ? h.navigationId && h.navigationId !== s.navigationId && function(I, A) {
            if (s = N("FCP", 0, I, A), r = O(e, s, ci, i.reportAllChanges), I === "soft-navigation") {
              a = je(!0);
              var Y = A ? B(A) : null;
              n = Y && Y.startTime || 0;
            }
          }("soft-navigation", h.navigationId) : v.disconnect();
          var w = 0;
          if (h.navigationId && h.navigationId !== l) {
            var y = B(h.navigationId), C = y && y.startTime ? y.startTime : 0;
            w = Math.max(h.startTime - C, 0);
          } else w = Math.max(h.startTime - Ke(), 0);
          var b = o && h.navigationId ? B(h.navigationId) : null, k = b && b.startTime ? b.startTime : 0;
          (h.startTime < a.firstHiddenTime || o && h.navigationId && h.navigationId !== s.navigationId && h.navigationId !== l && k > n) && (s.value = w, s.entries.push(h), s.navigationId = h.navigationId || "1", r(!0));
        }
      });
    }, i);
    v && (r = O(e, s, ci, i.reportAllChanges), we(function(g) {
      s = N("FCP", 0, "back-forward-cache", s.navigationId), r = O(e, s, ci, i.reportAllChanges), Xe(function() {
        s.value = performance.now() - g.timeStamp, r(!0);
      });
    }));
  });
}, fi = [0.1, 0.25], Ft = function(e, i) {
  (function(t, o) {
    var n = ge(o = o || {}), l = !1, r = 0;
    dt(lt(function() {
      var a, s = N("CLS", 0), v = 0, g = [], h = function(C, b) {
        if (s = N("CLS", 0, C, b), a = O(t, s, fi, o.reportAllChanges), v = 0, l = !1, C === "soft-navigation") {
          var k = B(b);
          r = k && k.startTime || 0;
        }
      }, w = function(C) {
        C.forEach(function(b) {
          if (n && b.navigationId && b.navigationId !== s.navigationId && (v > s.value && (s.value = v, s.entries = g), a(!0), h("soft-navigation", b.navigationId)), !b.hadRecentInput) {
            var k = g[0], I = g[g.length - 1];
            v && b.startTime - I.startTime < 1e3 && b.startTime - k.startTime < 5e3 ? (v += b.value, g.push(b)) : (v = b.value, g = [b]);
          }
        }), v > s.value && (s.value = v, s.entries = g, a());
      }, y = j("layout-shift", w, o);
      y && (a = O(t, s, fi, o.reportAllChanges), Ye(function() {
        w(y.takeRecords()), a(!0), l = !0;
      }), we(function() {
        h("back-forward-cache", s.navigationId), Xe(function() {
          return a();
        });
      }), n && j("soft-navigation", function(C) {
        C.forEach(function(b) {
          var k = b.navigationId, I = k ? B(k) : null;
          k && k !== s.navigationId && I && (I.startTime || 0) > r && (l || a(!0), h("soft-navigation", b.navigationId), a = O(t, s, fi, o.reportAllChanges));
        });
      }, o), setTimeout(a, 0));
    }));
  })(function(t) {
    var o = function(n) {
      var l, r = {};
      if (n.entries.length) {
        var a = n.entries.reduce(function(v, g) {
          return v && v.value > g.value ? v : g;
        });
        if (a && a.sources && a.sources.length) {
          var s = (l = a.sources).find(function(v) {
            return v.node && v.node.nodeType === 1;
          }) || l[0];
          s && (r = { largestShiftTarget: _i(s.node), largestShiftTime: a.startTime, largestShiftValue: a.value, largestShiftSource: s, largestShiftEntry: a, loadState: ze(a.startTime) });
        }
      }
      return Object.assign(n, { attribution: r });
    }(t);
    e(o);
  }, i);
}, Rt = function(e, i) {
  dt(function(t) {
    var o = function(n) {
      var l, r = ((l = D()) === null || l === void 0 ? void 0 : l.navigationId) || "1", a = { timeToFirstByte: 0, firstByteToFCP: n.value, loadState: ze(st()) };
      if (n.entries.length) {
        var s, v = n.entries[n.entries.length - 1], g = 0;
        if (n.navigationId && n.navigationId !== r) g = (s = B(n.navigationId)) ? s.startTime : 0;
        else if (s = D()) {
          var h = s.responseStart, w = s.activationStart || 0;
          g = Math.max(0, h - w);
        }
        s && (a = { timeToFirstByte: g, firstByteToFCP: n.value - g, loadState: ze(n.entries[0].startTime), navigationEntry: s, fcpEntry: v });
      }
      return Object.assign(n, { attribution: a });
    }(t);
    e(o);
  }, i);
}, ki = 0, Re = 1 / 0, Ee = 0, Be = "", ut = !1, Bt = function(e) {
  var i;
  Be || (Be = ((i = D()) === null || i === void 0 ? void 0 : i.navigationId) || "1"), e.forEach(function(t) {
    t.interactionId && (ut && t.navigationId && t.navigationId !== Be && (Be = t.navigationId, ki = 0, Re = 1 / 0, Ee = 0), Re = Math.min(Re, t.interactionId), Ee = Math.max(Ee, t.interactionId), ki = Ee ? (Ee - Re) / 7 + 1 : 0);
  });
}, ct = function() {
  return Ti ? ki : performance.interactionCount || 0;
}, Dt = function(e) {
  "interactionCount" in performance || Ti || (Ti = j("event", Bt, { type: "event", buffered: !0, durationThreshold: 0, includeSoftNavigationObservations: ut = e || !1 }));
}, H = [], _e = /* @__PURE__ */ new Map(), ft = 0, Ki = function() {
  ft = ct(), H.length = 0, _e.clear();
}, Nt = function() {
  var e = Math.min(H.length - 1, Math.floor((ct() - ft) / 50));
  return H[e];
}, pt = [], Ht = function(e) {
  if (pt.forEach(function(n) {
    return n(e);
  }), e.interactionId || e.entryType === "first-input") {
    var i = H[H.length - 1], t = _e.get(e.interactionId);
    if (t || H.length < 10 || e.duration > i.latency) {
      if (t) e.duration > t.latency ? (t.entries = [e], t.latency = e.duration) : e.duration === t.latency && e.startTime === t.entries[0].startTime && t.entries.push(e);
      else {
        var o = { id: e.interactionId, latency: e.duration, entries: [e] };
        _e.set(o.id, o), H.push(o);
      }
      H.sort(function(n, l) {
        return l.latency - n.latency;
      }), H.length > 10 && H.splice(10).forEach(function(n) {
        return _e.delete(n.id);
      });
    }
  }
}, Ai = function(e) {
  var i = self.requestIdleCallback || self.setTimeout, t = -1;
  return e = lt(e), document.visibilityState === "hidden" ? e() : (t = i(e), Ye(e)), t;
}, pi = [200, 500], Ut = function(e, i) {
  if ("PerformanceEventTiming" in self && "interactionId" in PerformanceEventTiming.prototype) {
    var t = ge(i = i || {}), o = !1, n = 0;
    Je(function() {
      var l;
      Dt(t);
      var r, a = N("INP"), s = function(h, w) {
        if (Ki(), a = N("INP", 0, h, w), r = O(e, a, pi, i.reportAllChanges), o = !1, h === "soft-navigation") {
          var y = B(w);
          n = y && y.startTime ? y.startTime : 0;
        }
      }, v = function(h) {
        Ai(function() {
          var w;
          h.forEach(Ht), (w = Nt()) && (w.latency !== a.value || i && i.reportAllChanges) && (a.value = w.latency, a.entries = w.entries), r();
        });
      }, g = j("event", v, { durationThreshold: (l = i.durationThreshold) !== null && l !== void 0 ? l : 40, opts: i });
      r = O(e, a, pi, i.reportAllChanges), g && (g.observe({ type: "first-input", buffered: !0, includeSoftNavigationObservations: t }), Ye(function() {
        v(g.takeRecords()), r(!0);
      }), we(function() {
        Ki(), s("back-forward-cache", a.navigationId), Xe(function() {
          return r();
        });
      }), t && j("soft-navigation", function(h) {
        h.forEach(function(w) {
          var y = B(w.navigationId), C = y && y.startTime ? y.startTime : 0;
          w.navigationId && w.navigationId !== a.navigationId && C > n && (!o && a.value > 0 && r(!0), s("soft-navigation", w.navigationId), r = O(e, a, pi, i.reportAllChanges));
        });
      }, i));
    });
  }
}, de = [], Q = [], Ci = 0, Li = /* @__PURE__ */ new WeakMap(), ue = /* @__PURE__ */ new Map(), Ei = -1, qt = function(e) {
  de = de.concat(e), vt();
}, vt = function() {
  Ei < 0 && (Ei = Ai(Vt));
}, Vt = function() {
  ue.size > 10 && ue.forEach(function(r, a) {
    _e.has(a) || ue.delete(a);
  });
  var e = H.map(function(r) {
    return Li.get(r.entries[0]);
  }), i = Q.length - 50;
  Q = Q.filter(function(r, a) {
    return a >= i || e.includes(r);
  });
  for (var t = /* @__PURE__ */ new Set(), o = 0; o < Q.length; o++) {
    var n = Q[o];
    wt(n.startTime, n.processingEnd).forEach(function(r) {
      t.add(r);
    });
  }
  var l = de.length - 1 - 50;
  de = de.filter(function(r, a) {
    return r.startTime > Ci && a > l || t.has(r);
  }), Ei = -1;
};
pt.push(function(e) {
  e.interactionId && e.target && !ue.has(e.interactionId) && ue.set(e.interactionId, e.target);
}, function(e) {
  var i, t = e.startTime + e.duration;
  Ci = Math.max(Ci, e.processingEnd);
  for (var o = Q.length - 1; o >= 0; o--) {
    var n = Q[o];
    if (Math.abs(t - n.renderTime) <= 8) {
      (i = n).startTime = Math.min(e.startTime, i.startTime), i.processingStart = Math.min(e.processingStart, i.processingStart), i.processingEnd = Math.max(e.processingEnd, i.processingEnd), i.entries.push(e);
      break;
    }
  }
  i || (i = { startTime: e.startTime, processingStart: e.processingStart, processingEnd: e.processingEnd, renderTime: t, entries: [e] }, Q.push(i)), (e.interactionId || e.entryType === "first-input") && Li.set(e, i), vt();
});
var wt = function(e, i) {
  for (var t, o = [], n = 0; t = de[n]; n++) if (!(t.startTime + t.duration < e)) {
    if (t.startTime > i) break;
    o.push(t);
  }
  return o;
}, zt = function(e, i) {
  Wi || (Wi = j("long-animation-frame", qt)), Ut(function(t) {
    var o = function(n) {
      var l = n.entries[0], r = Li.get(l), a = l.processingStart, s = r.processingEnd, v = r.entries.sort(function(k, I) {
        return k.processingStart - I.processingStart;
      }), g = wt(l.startTime, s), h = n.entries.find(function(k) {
        return k.target;
      }), w = h && h.target || ue.get(l.interactionId), y = [l.startTime + l.duration, s].concat(g.map(function(k) {
        return k.startTime + k.duration;
      })), C = Math.max.apply(Math, y), b = { interactionTarget: _i(w), interactionTargetElement: w, interactionType: l.name.startsWith("key") ? "keyboard" : "pointer", interactionTime: l.startTime, nextPaintTime: C, processedEventEntries: v, longAnimationFrameEntries: g, inputDelay: a - l.startTime, processingDuration: s - a, presentationDelay: Math.max(C - s, 0), loadState: ze(l.startTime) };
      return Object.assign(n, { attribution: b });
    }(t);
    e(o);
  }, i);
}, Yi = [2500, 4e3], $t = function(e, i) {
  (function(t, o) {
    var n, l = !1, r = ge(o = o || {}), a = 0, s = ((n = D()) === null || n === void 0 ? void 0 : n.navigationId) || "1", v = "";
    Je(function() {
      var g, h = je(), w = N("LCP"), y = function(F, x) {
        if (w = N("LCP", 0, F, x), g = O(t, w, Yi, o.reportAllChanges), l = !1, F === "soft-navigation") {
          h = je(!0);
          var q = B(x);
          a = q && q.startTime ? q.startTime : 0;
        }
        k();
      }, C = function(F) {
        F.forEach(function(x) {
          if (x) {
            r && x.navigationId && x.navigationId !== w.navigationId && (l || g(!0), y("soft-navigation", x.navigationId));
            var q = 0;
            if (x.navigationId && x.navigationId !== s) {
              var Ze = B(x.navigationId), ht = Ze && Ze.startTime ? Ze.startTime : 0;
              q = Math.max(x.startTime - ht, 0);
            } else q = Math.max(x.startTime - Ke(), 0);
            x.startTime < h.firstHiddenTime && (w.value = q, w.entries = [x], w.navigationId = x.navigationId || s, g());
          }
        });
      }, b = function() {
        I(), l || (C(Y.takeRecords()), r || Y.disconnect(), w.navigationId === v && (l = !0, g(!0)));
      }, k = function() {
        ["keydown", "click"].forEach(function(F) {
          addEventListener(F, function() {
            return A();
          }, !0);
        });
      }, I = function() {
        ["keydown", "click"].forEach(function(F) {
          removeEventListener(F, function() {
            return A();
          }, !0);
        });
      }, A = function() {
        v = w.navigationId, Ai(b);
      }, Y = j("largest-contentful-paint", C, o);
      Y && (g = O(t, w, Yi, o.reportAllChanges), k(), Ye(function() {
        v = w.navigationId, b();
      }), we(function(F) {
        y("back-forward-cache", w.navigationId), Xe(function() {
          w.value = performance.now() - F.timeStamp, l = !0, g(!0);
        });
      }), r && j("soft-navigation", function(F) {
        F.forEach(function(x) {
          var q = x.navigationId ? B(x.navigationId) : null;
          x.navigationId && x.navigationId !== w.navigationId && q && (q.startTime || 0) > a && (l || g(!0), y("soft-navigation", x.navigationId));
        });
      }, o));
    });
  })(function(t) {
    var o = function(n) {
      var l, r = ((l = D()) === null || l === void 0 ? void 0 : l.navigationId) || "1", a = { timeToFirstByte: 0, resourceLoadDelay: 0, resourceLoadDuration: 0, elementRenderDelay: n.value };
      if (n.entries.length) {
        var s, v = 0, g = 0, h = 0;
        if (n.navigationId && n.navigationId !== r ? v = h = (s = B(n.navigationId)) ? s.startTime : 0 : (v = (s = D()) && s.activationStart ? s.activationStart : 0, g = s && s.responseStart ? s.responseStart : 0), s) {
          var w = n.entries[n.entries.length - 1], y = w.url && performance.getEntriesByType("resource").filter(function(A) {
            return A.name === w.url;
          })[0], C = Math.max(0, g - v), b = Math.max(C, y ? (y.requestStart || y.startTime) - v : 0), k = Math.max(b - h, y ? y.responseEnd - v : 0, 0), I = Math.max(k - h, w ? w.startTime - v : 0, 0);
          a = { element: _i(w.element), timeToFirstByte: C, resourceLoadDelay: b - C, resourceLoadDuration: k - b, elementRenderDelay: I - k, navigationEntry: s, lcpEntry: w }, w.url && (a.url = w.url), y && (a.lcpResourceEntry = y);
        }
      }
      return Object.assign(n, { attribution: a });
    }(t);
    e(o);
  }, i);
}, vi = [800, 1800], jt = function e(i) {
  document.prerendering ? Je(function() {
    return e(i);
  }) : document.readyState !== "complete" ? addEventListener("load", function() {
    return e(i);
  }, !0) : setTimeout(i, 0);
}, Wt = function(e, i) {
  var t = ge(i = i || {}), o = N("TTFB"), n = O(e, o, vi, i.reportAllChanges);
  jt(function() {
    var l = D();
    if (l) {
      var r = l.responseStart;
      o.value = Math.max(r - Ke(), 0), o.entries = [l], n(!0), we(function() {
        o = N("TTFB", 0, "back-forward-cache", o.navigationId), (n = O(e, o, vi, i.reportAllChanges))(!0);
      }), t && j("soft-navigation", function(a) {
        a.forEach(function(s) {
          s.navigationId && ((o = N("TTFB", 0, "soft-navigation", s.navigationId)).entries = [s], (n = O(e, o, vi, i.reportAllChanges))(!0));
        });
      }, i);
    }
  });
}, Gt = function(e, i) {
  Wt(function(t) {
    var o = function(n) {
      var l = { waitingDuration: 0, cacheDuration: 0, dnsDuration: 0, connectionDuration: 0, requestDuration: 0 };
      if (n.entries.length) {
        var r = n.entries[0], a = r.activationStart || 0, s = Math.max((r.workerStart || r.fetchStart) - a, 0), v = Math.max(r.domainLookupStart - a || 0, 0), g = Math.max(r.connectStart - a || 0, 0), h = Math.max(r.connectEnd - a || 0, 0);
        l = { waitingDuration: s, cacheDuration: v - s, dnsDuration: g - v, connectionDuration: h - g, requestDuration: n.value - h, navigationEntry: r };
      }
      return Object.assign(n, { attribution: l });
    }(t);
    e(o);
  }, i);
}, xe = (e, i, t, o) => {
  i.set(t, o), document.dispatchEvent(new CustomEvent("reshepe-web-vitals-data-set", { detail: { type: e, data: o } }));
}, T = { LCP: { good: 2500, poor: 4e3, floor: 1e4 }, INP: { good: 200, poor: 500, floor: 1e3 }, CLS: { good: 0.1, poor: 0.25, floor: 1 }, TTFB: { good: 800, poor: 1800, floor: 5e3 }, FCP: { good: 1800, poor: 3e3, floor: 1e4 } }, _ = (e, i, t) => {
  let o = (t.value - i.value) / (t.percent - i.percent), n = i.percent + (i.value - e) / Math.abs(o);
  return parseInt(n.toFixed(0), 10);
}, wi = null, Ji = null, Ne = null, gt = !1, Zi = (e, i = !1) => {
  if (e || console.info("[reshepe web vitals]: running in developer mode, data will not be send to the server"), wi = new K(navigator.userAgent), Ji = wi.getUA(), Ne = wi.getDevice(), Ji === "reshepe-speed-insights/1.0") {
    gt = !0;
    return;
  }
  window.reshepe_web_vitals = window.reshepe_web_vitals || { LCP: /* @__PURE__ */ new Map(), INP: /* @__PURE__ */ new Map(), CLS: /* @__PURE__ */ new Map(), TTFB: /* @__PURE__ */ new Map(), FCP: /* @__PURE__ */ new Map() }, $t((t) => {
    let { id: o, rating: n, value: l, attribution: r } = t, a;
    if (l <= T.LCP.good ? a = _(l, { percent: 90, value: T.LCP.good }, { percent: 100, value: 0 }) : l <= T.LCP.poor ? a = _(l, { percent: 50, value: T.LCP.poor }, { percent: 90, value: T.LCP.good }) : a = _(l, { percent: 0, value: T.LCP.floor }, { percent: 50, value: T.LCP.poor }), a > -100) {
      let s = { rating: n, value: l, element: r.lcpEntry?.element, score: Math.max(0, a) };
      xe("LCP", window.reshepe_web_vitals.LCP, o, s);
    }
  }, { reportAllChanges: !0, reportSoftNavs: i }), zt((t) => {
    let { id: o, rating: n, value: l, attribution: r } = t, a;
    if (l <= T.INP.good ? a = _(l, { percent: 90, value: T.INP.good }, { percent: 100, value: 0 }) : l <= T.INP.poor ? a = _(l, { percent: 50, value: T.INP.poor }, { percent: 90, value: T.INP.good }) : a = _(l, { percent: 0, value: T.INP.floor }, { percent: 50, value: T.INP.poor }), a > -100) {
      let s = { rating: n, value: l, element: r.interactionTargetElement, score: Math.max(0, a) };
      xe("INP", window.reshepe_web_vitals.INP, o, s);
    }
  }, { reportAllChanges: !0, reportSoftNavs: i }), Ft((t) => {
    let { id: o, rating: n, value: l, attribution: r } = t, a;
    if (l <= T.CLS.good ? a = _(l, { percent: 90, value: T.CLS.good }, { percent: 100, value: 0 }) : l <= T.CLS.poor ? a = _(l, { percent: 50, value: T.CLS.poor }, { percent: 90, value: T.CLS.good }) : a = _(l, { percent: 0, value: T.CLS.floor }, { percent: 50, value: T.CLS.poor }), a > -100) {
      let s = { rating: n, value: l, element: r.largestShiftSource?.node, score: Math.max(0, a) };
      xe("CLS", window.reshepe_web_vitals.CLS, o, s);
    }
  }, { reportAllChanges: !0, reportSoftNavs: i }), Gt((t) => {
    let { id: o, rating: n, value: l } = t;
    if (l <= 0) return;
    let r;
    if (l <= T.TTFB.good ? r = _(l, { percent: 90, value: T.TTFB.good }, { percent: 100, value: 0 }) : l <= T.TTFB.poor ? r = _(l, { percent: 50, value: T.TTFB.poor }, { percent: 90, value: T.TTFB.good }) : r = _(l, { percent: 0, value: T.TTFB.floor }, { percent: 50, value: T.TTFB.poor }), r > -100) {
      let a = { rating: n, value: l, element: void 0, score: Math.max(0, r) };
      xe("TTFB", window.reshepe_web_vitals.TTFB, o, a);
    }
  }, { reportAllChanges: !0, reportSoftNavs: i }), Rt((t) => {
    let { id: o, rating: n, value: l } = t, r;
    if (l <= T.FCP.good ? r = _(l, { percent: 90, value: T.FCP.good }, { percent: 100, value: 0 }) : l <= T.FCP.poor ? r = _(l, { percent: 50, value: T.FCP.poor }, { percent: 90, value: T.FCP.good }) : r = _(l, { percent: 0, value: T.FCP.floor }, { percent: 50, value: T.FCP.poor }), r > -100) {
      let a = { rating: n, value: l, element: void 0, score: Math.max(0, r) };
      xe("FCP", window.reshepe_web_vitals.FCP, o, a);
    }
  }, { reportAllChanges: !0, reportSoftNavs: i });
}, gi = (e, i, t, o) => {
  if (gt) return;
  let n = { api_key: i, path: e.length > 1 ? e.replace(/\/$/, "") : e, version: t, platform: o, desktop: !0, metrics: { LCP: [...new Set(Array.from(window.reshepe_web_vitals.LCP, ([r, { rating: a, value: s, score: v }]) => ({ id: r, rating: a, value: s, score: v })))], INP: [...new Set(Array.from(window.reshepe_web_vitals.INP, ([r, { rating: a, value: s, score: v }]) => ({ id: r, rating: a, value: s, score: v })))], CLS: [...new Set(Array.from(window.reshepe_web_vitals.CLS, ([r, { rating: a, value: s, score: v }]) => ({ id: r, rating: a, value: s, score: v })))], TTFB: [...new Set(Array.from(window.reshepe_web_vitals.TTFB, ([r, { rating: a, value: s, score: v }]) => ({ id: r, rating: a, value: s, score: v })))], FCP: [...new Set(Array.from(window.reshepe_web_vitals.FCP, ([r, { rating: a, value: s, score: v }]) => ({ id: r, rating: a, value: s, score: v })))] } };
  if (!Object.keys(n.metrics).some((r) => n.metrics[r].length > 0) || !Ne) return;
  n.desktop = Ne.type === void 0 || !["wearable", "mobile"].includes(Ne.type);
  let l = JSON.stringify(n);
  navigator.sendBeacon ? navigator.sendBeacon("https://ingest.api.reshepe.dev/v1/collect/web-vitals", l) : fetch("https://ingest.api.reshepe.dev/v1/collect/web-vitals", { method: "POST", keepalive: !0, headers: { "Content-Type": "application/json" }, body: l });
}, Xt = () => {
  console.error("[reshepe web vitals]: missing api key, please visit https://docs.reshepe.dev/web-vitals/introduction for more information");
}, Qi = () => {
  window.reshepe_web_vitals = { LCP: /* @__PURE__ */ new Map(), INP: /* @__PURE__ */ new Map(), CLS: /* @__PURE__ */ new Map(), TTFB: /* @__PURE__ */ new Map(), FCP: /* @__PURE__ */ new Map() }, document.dispatchEvent(new CustomEvent("reshepe-web-vitals-data-clear", {}));
};
const nn = /* @__PURE__ */ it({
  __name: "core",
  props: {
    apiKey: {},
    development: { type: Boolean, default: !1 },
    reportSoftNavigation: { type: Boolean, default: !1 }
  },
  setup(e) {
    const i = e, t = Qe(!0), o = Qe(!1), n = Qe(!1), l = "0.1.0", r = mt(), a = bt();
    return r.beforeEach(async (s, v) => {
      if (t.value) {
        t.value = !1;
        return;
      }
      typeof window > "u" || (o.value || (Zi(!i.development, i.reportSoftNavigation), o.value = !0), i.reportSoftNavigation ? (i.apiKey && !i.development && (n.value = !0, gi(
        v.path,
        i.apiKey,
        l,
        "vue"
      )), Qi()) : n.value || i.apiKey && !i.development && (n.value = !0, gi(
        v.path,
        i.apiKey,
        l,
        "vue"
      )));
    }), tt(() => {
      i.apiKey ? (o.value || (Zi(!i.development, i.reportSoftNavigation), o.value = !0), addEventListener("visibilitychange", () => {
        document.visibilityState === "hidden" && i.apiKey && !i.development && (n.value = !0, gi(
          a.path,
          i.apiKey,
          l,
          "vue"
        ), Qi());
      })) : Xt();
    }), () => {
    };
  }
});
var Le = { LCP: { key: "lcp", title: "Largest Contentful Paint", nodes: { wrapper: null, fill: null, value: null } }, INP: { key: "inp", title: "Interaction to Next Paint", nodes: { wrapper: null, fill: null, value: null } }, CLS: { key: "cls", title: "Cumulative Layout Shift", nodes: { wrapper: null, fill: null, value: null } }, TTFB: { key: "ttfb", title: "Time to First Byte", nodes: { wrapper: null, fill: null, value: null } }, FCP: { key: "fcp", title: "First Contentful Paint", nodes: { wrapper: null, fill: null, value: null } } }, He = { success: "#76c893", warning: "#d2b05f", error: "#87233f", unknown: "#5d6462" }, Kt = `
    <style>
        #reshepe-web-vitals-toolbar {
            position: fixed;
            left: 0;
            right: 0;
            bottom: 1rem;
            height: 64px;
            background-color: #141619;
            z-index: 9999999999;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1rem;
            color: #fff;
            margin-left: auto;
            margin-right: auto;
            margin-inline: auto; 
            width: fit-content;
            padding: 0.4rem;
            border-radius: 0.5rem;
            opacity: 0.8;
            transition: opacity 0.2s ease-in-out;
        }
        
        #reshepe-web-vitals-toolbar:hover {
            opacity: 1;
        }
        
        .reshepe-web-vitals-toolbar-logo {
            width: 32px;
            height: 32px;
        }

        .reshepe-web-vitals-toolbar-logo--image {
            width: 32px;
            height: 32px;
        }
        
        .reshepe-web-vitals-toolbar-metrics {
            display: flex;
            flex-direction: row;
            gap: 0.4rem;
        }
        
        .reshepe-web-vitals-toolbar-metrics-item {
            display: flex;
            align-items: center;
            position: relative;
        }
        
        .reshepe-web-vitals-toolbar-metrics-item-icon {
            width: 48px;
            height: 48px;
        }
        
        .reshepe-web-vitals-toolbar-metrics-item-rail {
            stroke-width: 4;
            stroke-linecap: round;
            fill: none;
            stroke-dasharray: 315px, 800px;
            stroke-dashoffset: 0;
            stroke: #5d6462;
        }
        
        .reshepe-web-vitals-toolbar-metrics-item-fill {
            stroke-width: 4;
            stroke-linecap: round;
            fill: none;
            stroke-dasharray: 0, 800px;
            stroke-dashoffset: 0;
            transform-origin: center center;
            transform: rotate(180deg);
            stroke: #76c893;
            transition: stroke-dasharray 0.6s ease-in-out;
        }
        
        .reshepe-web-vitals-toolbar-metrics-item-value {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            display: flex;
            align-items: center;
            font-size: 0.65rem;
            white-space: nowrap;
            font-family: arial, sans-serif;
        }
    </style>
`, Yt = (e, i) => e === "CLS" ? i.toFixed(2) : i.toFixed(0), Jt = (e) => e * 316 / 100, et = (e, i) => {
  let t = Le[e];
  if (t.nodes.value && (t.nodes.value.textContent = Yt(e, i.value)), t.nodes.wrapper) {
    if (i.element) {
      let o = i.element;
      t.nodes.wrapper.onclick = () => {
        o.scrollIntoView({ behavior: "smooth" });
        let n = o.style.boxShadow, l = o.style.backgroundColor;
        o.style.boxShadow = `0 0 0 1px ${He.warning}`, o.style.backgroundColor = He.warning, setTimeout(() => {
          o.style.boxShadow = n, o.style.backgroundColor = l;
        }, 1e3);
      }, t.nodes.wrapper.style.cursor = "pointer";
    } else t.nodes.wrapper.onclick = null, t.nodes.wrapper.style.cursor = "default";
    if (t.nodes.fill) {
      let o;
      i.score >= 90 ? o = "success" : i.value >= 50 ? o = "warning" : o = "error";
      let n = Jt(i.score);
      t.nodes.fill.style.strokeDasharray = `${n}px`, t.nodes.fill.style.stroke = He[o];
    }
  }
}, Zt = () => {
  for (let e of Object.keys(Le)) {
    let i = Le[e];
    i.nodes.wrapper && (i.nodes.wrapper.onclick = null, i.nodes.wrapper.style.cursor = "default"), i.nodes.fill && (i.nodes.fill.style.strokeDasharray = "0", i.nodes.fill.style.stroke = He.unknown), i.nodes.value && (i.nodes.value.textContent = "-");
  }
}, Qt = (e) => {
  let i = document.createElement("div");
  i.id = "reshepe-web-vitals-toolbar-wrapper";
  let t = i.attachShadow({ mode: "closed" });
  t.innerHTML = Kt, document.body.appendChild(i);
  let o = document.createElement("div");
  o.id = "reshepe-web-vitals-toolbar";
  let n = document.createElement("div");
  n.className = "reshepe-web-vitals-toolbar-logo";
  let l = document.createElement("img");
  l.className = "reshepe-web-vitals-toolbar-logo--image", l.src = e, l.alt = "reshepe logo", n.appendChild(l), o.appendChild(n);
  let r = document.createElement("div");
  r.className = "reshepe-web-vitals-toolbar-metrics";
  for (let a of Object.keys(Le)) {
    let s = Le[a], v = document.createElement("div");
    v.id = `reshepe-web-vitals-toolbar-metrics-${s.key}`, v.className = "reshepe-web-vitals-toolbar-metrics-item", v.title = s.title;
    let g = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    g.setAttribute("viewBox", "0 0 110 110"), g.classList.add("reshepe-web-vitals-toolbar-metrics-item-icon");
    let h = document.createElementNS("http://www.w3.org/2000/svg", "g"), w = document.createElementNS("http://www.w3.org/2000/svg", "path");
    w.classList.add("reshepe-web-vitals-toolbar-metrics-item-rail"), w.setAttribute("d", "M 55,55 m 0,50 a 50,50 0 1 1 0,-100 a 50,50 0 1 1 0,100"), h.appendChild(w), g.appendChild(h);
    let y = document.createElementNS("http://www.w3.org/2000/svg", "g"), C = document.createElementNS("http://www.w3.org/2000/svg", "path");
    C.classList.add("reshepe-web-vitals-toolbar-metrics-item-fill"), C.setAttribute("d", "M 55,55 m 0,50 a 50,50 0 1 1 0,-100 a 50,50 0 1 1 0,100"), y.appendChild(C), g.appendChild(y), v.appendChild(g);
    let b = document.createElement("span");
    b.className = "reshepe-web-vitals-toolbar-metrics-item-value", b.textContent = "-", v.appendChild(b), r.appendChild(v), s.nodes.wrapper = v, s.nodes.fill = C, s.nodes.value = b;
  }
  o.appendChild(r), t.appendChild(o), setTimeout(() => {
    if (window.reshepe_web_vitals) for (let a of Object.keys(window.reshepe_web_vitals)) window.reshepe_web_vitals[a].forEach((s) => {
      et(a, s);
    });
    document.addEventListener("reshepe-web-vitals-data-set", ({ detail: a }) => {
      et(a.type, a.data);
    }), document.addEventListener("reshepe-web-vitals-data-clear", () => {
      Zt();
    });
  }, 200);
};
const rn = /* @__PURE__ */ it({
  __name: "toolbar",
  setup(e) {
    return tt(() => {
      Qt("https://reshepe.dev/images/pwa/icon-128x128.png");
    }), () => {
    };
  }
});
export {
  rn as Toolbar,
  nn as WebVitals
};
